var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthTips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C8.13 2 5 5.13 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.87-3.13-7-7-7zm0 2c2.76 0 5 2.24 5 5 0 1.96-1.12 3.68-2.75 4.52L14 15.27V16h-4v-.73l-.25-.75C8.12 14.68 7 12.96 7 11c0-2.76 2.24-5 5-5zm-2 14h4v1h-4v-1z",
    fill: "#2F4C21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.5c-.55.85-.95 1.95-.95 3.2 0 1.75.7 3.1 1.75 4.15-.35-1.1-.55-2.2-.55-3.35 0-1 .2-1.95.55-2.8h-.8z",
    fill: "#2F4C21",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthTips);
export default __webpack_public_path__ + "static/media/health_tips.dbf5176f79a0fb3c6d863053572ce9db.svg";
export { ForwardRef as ReactComponent };